// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xdCd","title":"styles_title__JQ0qf"};